
<mat-card class="login-info-screen-wrapper">
    <div class="icon">
        <img src="assets/icons/illustration-help-center-payment@3x.svg" alt="success-icon">
    </div>
    <div class="title">{{"PURCHASE.COMPLETE_PURCHASE_HEADLINE" | translate}}</div>
    <div class="text">{{"PURCHASE.COMPLETE_PURCHASE_TEXT" | translate}}</div>
    <button (click)="goToRedirectUrl()"> {{'PURCHASE.WIX_CHECKOUT' | translate}}</button>
</mat-card>
